import { AfterViewInit, ChangeDetectorRef, Component, Inject, OnDestroy, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { BusService } from 'src/app/shared/services/bus.service';
import { DialogEntityManagerExt, ListenerHeaderDetailAction, MessageBusListener, ReponseDialogEntityManager } from '../../global';
import { BusListener } from '../../decorators/comp.decorator';

@BusListener(MessageBusListener.Dialog)
@Component({
  selector: 'app-tin-dialog-entity-manager',
  templateUrl: './tin-dialog-entity-manager.component.html',
  styleUrls: ['./tin-dialog-entity-manager.component.scss']
})
export class TinDialogEntityManagerComponent implements OnDestroy, OnInit, AfterViewInit {
  
  @ViewChild("container", { read: ViewContainerRef, static: true }) container!: ViewContainerRef;

  componentRef:any;
  dialogId: string = "";
  headerTitle = "";

  private sub = new Subscription();
 
  constructor(
    private dialogRef: MatDialogRef<TinDialogEntityManagerComponent>, @Inject(MAT_DIALOG_DATA) public data: DialogEntityManagerExt,
    private viewContainerRef: ViewContainerRef,
    private changeDetectorRef: ChangeDetectorRef,
    private serviceBus: BusService,
  ) { }

  ngOnInit(): void {
    this.dialogId = this.data.id;
  }

  ngAfterViewInit(): void {
    this.loadComponent();
    if (this.data?.headerDetail) {
      this.serviceBus.sendMessageToHeaderDetail(this.data?.headerDetail, undefined, this.dialogId);
    }
  }
  
  loadComponent(): void {
    this.container.clear();
    this.componentRef = this.viewContainerRef.createComponent(this.data?.component);
    if (this.componentRef.instance) {
      this.componentRef.instance.dialogEntityManager = this.data;
    }
    const comp = this.viewContainerRef.get(0);
    if (comp) {
      this.container.insert(comp);
    }
    this.changeDetectorRef.detectChanges();
  }


  okAndClose(item: any, dialogId: string): void {
    if (dialogId === this.dialogId) {
      this.dialogRef.close({response: ReponseDialogEntityManager.Ok, item });
    }
  }
  deleteAndClose(item: any, dialogId: string): void {
    if (dialogId === this.dialogId) {
      this.dialogRef.close({response: ReponseDialogEntityManager.Delete, item });
    }
  }

  _saveAndClose(data: any, dialogId: string) { 
    if (dialogId === this.dialogId) {
      if (this.data?.saveAndCloseActionName && this.componentRef.instance) {
        const action = this.componentRef.instance[this.data.saveAndCloseActionName];
        if (typeof action === 'function') {
          action.call(this.componentRef.instance);
        }
      }
    }
  }

  _cancel(data: any, dialogId: string): void {
    if (dialogId === this.dialogId) {
      this.componentRef.destroy();
      this.container.clear();
      this.loadComponent();
      this.serviceBus.sendMessageToHeaderDetail(ListenerHeaderDetailAction.FormIsDirtyChanged,{isDirty : false}, this.dialogId);
    }
  }

  _customAction(item: any, dialogId: string): void {
    if (dialogId === this.dialogId) {
      this.dialogRef.close({response: ReponseDialogEntityManager.Custom, item });
    }
  }

  _close(data: any, dialogId: string): void {
    if (dialogId === this.dialogId) {
      this.dialogRef.close({response: ReponseDialogEntityManager.Cancel});
    }
  }

  _expand(data: any, dialogId: string): void {
    if (dialogId === this.dialogId) {
      this.dialogRef.updateSize('100%', '100%');
    }
  }

  _shrink(data: any, dialogId: string): void {
    if (dialogId === this.dialogId) {
      this.dialogRef.updateSize(this.data?.width, this.data?.height);
    }
  }

  ngOnDestroy(): void {
    if (this.container) {
      this.container.clear();
    }
    if (this.componentRef) {
      this.componentRef.destroy();
    }
    this.sub.unsubscribe();
  }

}
